import Cookies from 'js-cookie';
import { HttpClient } from "./HttpClient";

const COURIER_TOKEN_KEY = 'courier_token';
const TOKEN_EXPIRY_DAYS = 1;

// Notification types
export interface EmailNotification {
    id: string;
    name: string;
    category: string;
    disabled: boolean;
}

export interface InAppNotification {
    id: string;
    title: string;
    category: string;
    disabled: boolean;
}

export interface CategoryNotifications {
    email: EmailNotification[];
    inApp: InAppNotification[];
}

export interface NotificationPreferences {
    [category: string]: CategoryNotifications;
}

export interface NotificationPreferencesUpdate {
    id: string;
    category: string;
    type: 'email' | 'inApp';
    name: string;
    disabled: boolean;
}

export const notificationService = {
    async authCourer(): Promise<string> {
        const existingToken = Cookies.get(COURIER_TOKEN_KEY);
        if (existingToken) return existingToken;

        const response = await HttpClient.apiClient.get('/profile/notifications/courier/authenticate');

        const token = response.data?.data?.token;
        if (token) Cookies.set(COURIER_TOKEN_KEY, token, { expires: TOKEN_EXPIRY_DAYS });

        return token;
    },

    async getNotificationPreferences(): Promise<NotificationPreferences> {
        const response = await HttpClient.apiClient.get('/profile/notifications/preferences');
        return response?.data?.data;
    },

    async updateNotificationPreferences(changedData: NotificationPreferencesUpdate[]): Promise<any> {
        const response = await HttpClient.apiClient.put('/profile/notifications/preferences', changedData);
        return response?.data?.data;
    }
};